export default "__VITE_ASSET__Brpl45u5__"